import React from 'react';
import { Tag, Tooltip } from 'antd';

export interface SpecBadgeProps {
  source?: string;
  attribution?: string;
  min?: number;
  max?: number;
  units?: string;
}

const COLOR_BY_SOURCE: Record<string, string> = {
  alldata: 'green',
  hub_cache: 'blue',
  hub_free: 'blue',
  ai_estimate: 'orange',
  manual: 'default',
};

const LABEL_BY_SOURCE: Record<string, string> = {
  alldata: 'FROM ALLDATA',
  hub_cache: 'CACHED',
  hub_free: 'CACHED',
  ai_estimate: 'AI ESTIMATE · VERIFY',
  manual: 'MANUAL',
};

export const SpecBadge: React.FC<SpecBadgeProps> = ({ source, attribution, min, max, units }) => {
  if (!source) return <Tag>spec pending</Tag>;
  return (
    <Tooltip title={attribution}>
      <Tag color={COLOR_BY_SOURCE[source]} style={{ fontWeight: 600 }}>
        {LABEL_BY_SOURCE[source] ?? source.toUpperCase()} · {min}
        {max ? `–${max}` : ''} {units ?? ''}
      </Tag>
    </Tooltip>
  );
};
